import { createContext } from "react";

export const initialProactiveMatchModalsContext = {
    showPaymentModalsIfNecessary: async (_eventDate?: string) => false,
};

export const PayUsModalsContext = createContext(
    initialProactiveMatchModalsContext,
);
